import { render, staticRenderFns } from "./NewsletterButton.vue?vue&type=template&id=47ba291c&scoped=true"
import script from "./NewsletterButton.vue?vue&type=script&lang=js"
export * from "./NewsletterButton.vue?vue&type=script&lang=js"
import style0 from "./NewsletterButton.vue?vue&type=style&index=0&id=47ba291c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba291c",
  null
  
)

export default component.exports